window.custom = window.custom || {};

var currentBreakpoint;

$(document).ready(function() {
    custom.refreshBreakpointValue();
    custom.singleAccordian();
    custom.matchHeightsInGrid('[data-match-heights-product-features]', '.match-this', 'medium');
    custom.matchHeightsInGrid('[data-match-heights-split-banner]', '.match-this', 'large');
    custom.matchHeightsInGrid('[data-match-heights-columns-medium]', '.match-this', 'medium');
    custom.modalVideo();
    custom.mainContentMarginToMatchFixedHeader();

    custom.galleryModals();


});

$(window).load(function() {
    custom.gallerySort();
});

$(window).on('resize', function () {
    custom.refreshBreakpointValue();
    custom.matchHeightsInGrid('[data-match-heights-product-features]', '.match-this', 'medium');
    custom.matchHeightsInGrid('[data-match-heights-split-banner]', '.match-this', 'large');
    custom.matchHeightsInGrid('[data-match-heights-columns-medium]', '.match-this', 'medium');
    custom.mainContentMarginToMatchFixedHeader();
});

custom.galleryModals = function() {
    $('.open-popup-link').magnificPopup({
      type:'inline',
      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });
}


// Detect current CSS breakpoint - uses body::before content property's value
custom.refreshBreakpointValue = function() {
    currentBreakpoint = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};


custom.singleAccordian = function() {

    var $element = $('[data-single-accordian]');

    $element.each(function() {
        $(this).find('.testimonial-heading-container').on('click', function() {
            $(this).parent('[data-single-accordian]').find('.testimonial-content').toggleClass('is-active');
            $(this).parent('[data-single-accordian]').find('.arrow-down').toggleClass('is-active');
        });
    });
}

custom.matchHeightsInGrid = function(targetGrid, targetClass, breakpoint) {

    if (breakpoint == 'medium') {
        if (currentBreakpoint == 'small') {

            var $element = $(targetGrid);

            $element.find(targetClass).each(function() {
                $(this).height('auto');
            });

        //start from medium
        } else if (currentBreakpoint == 'medium' || currentBreakpoint == 'large') {
            var $element = $(targetGrid);

            $element.find(targetClass).each(function() {
                $(this).height('auto');
            });

            var height = 0;

            $element.find(targetClass).each(function() {
                if ( $(this).height() > height ) {
                    height = $(this).height();
                }
            });

            $element.find(targetClass).each(function() {
                $(this).height(height);
            });
        }
    } else if (breakpoint == 'large') {
        if (currentBreakpoint == 'small' || currentBreakpoint == 'medium') {

            var $element = $(targetGrid);

            $element.find(targetClass).each(function() {
                $(this).height('auto');
            });

        //start from medium
        } else if (currentBreakpoint == 'large') {
            var $element = $(targetGrid);

            $element.find(targetClass).each(function() {
                $(this).height('auto');
            });

            var height = 0;

            $element.find(targetClass).each(function() {
                if ( $(this).height() > height ) {
                    height = $(this).height();
                }
            });

            $element.find(targetClass).each(function() {
                $(this).height(height);
            });
        }
    }
}
$(function(){
$("#ProductThumbs li img").each(function () {
        var img = $(this);
        img.attr('height', '60');
        img.attr('width', '60');
});
  $("img.productImg").each(function () {
        var img = $(this);
        img.attr('height', '1000');
        img.attr('width', '1000');
});
  $("img.logo-image").each(function () {
        var img = $(this);
        img.attr('height', '200');
        img.attr('width', '200');
});
});

custom.modalVideo = function() {

    $(".js-modal-btn").modalVideo({channel:'vimeo'});
}

custom.mainContentMarginToMatchFixedHeader = function() {
	var headerHeight = $('.header__wrapper').outerHeight();

  	$('.main-content').css('margin-top', headerHeight);
}

custom.pinterestAddToCartPixel = function() {
  pintrk('track', 'addtocart');
}

custom.gallerySort = function() {
    // init Isotope
    var $grid = $('.gallery-grid').isotope({
        // options
      });
      // filter items on button click
      $('.filter-button-group').on( 'click', 'span', function() {
          if ( $(this).attr('data-filter') ==  '*' ) {
              $grid.isotope({ filter: '*' });
          } else {
              var filterValue = $(this).attr('data-filter');
              $grid.isotope({ filter: filterValue });
          }
      });
}


